import axios from "axios"
import { baseUrl } from "./BaseUrl";
export const PostMethod = (routeName,body, auth) => {
    var headers = [];
    if (!auth) {
      headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: auth,
      };
    }
    return new Promise(async (resolve, reject) => {
        try {
        console.log(routeName,body,auth)
          const response = await axios.post(
            `${baseUrl}/${routeName}`,
            body,
            {headers}
          );
          
          return resolve({ result: response.data});
        } catch (err) {
          return reject({ result: "failed", message: err });
        }
      });
  };